import { Validators } from '@angular/forms';

export const e164PhoneValidators = [Validators.required, Validators.pattern(/^\+[1-9]\d{10,14}$/)];
